// frontend/src/layouts/ReelsLayout.jsx

import React from 'react';
import { Outlet } from 'react-router-dom';
import TopNavigationBar from '../components/layout/TopNavigationBar';
import BottomNavigationBar from '../components/layout/BottomNavigationBar';
import './ReelsLayout.css'; // We will create this new CSS file next

const ReelsLayout = () => {
  return (
    <div className="reels-layout">
      {/* The header is absolutely positioned so it doesn't affect the layout flow */}
      <header className="reels-layout-header">
        <TopNavigationBar />
      </header>

      {/* The main content area will hold our ReelsPage */}
      <main className="reels-layout-main">
        <Outlet />
      </main>

      {/* The footer is absolutely positioned for mobile-first feel */}
      <footer className="reels-layout-footer">
        <BottomNavigationBar />
      </footer>
    </div>
  );
};

export default ReelsLayout;